export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M11.375 12.625V17H12.625V12.625H17V11.375H12.625V7H11.375V11.375H7V12.625H11.375Z" fill="black" />
    </svg>
  )
}